import React from 'react';
import { Route } from 'react-router-dom';

interface RouteWithLayoutProps {
  layout: any;
  component: any;
  path: string;
  exact: boolean;
}

const RouteWithLayout = (props: RouteWithLayoutProps) => {
  const { component: Component, layout: Layout, ...rest } = props;
  return (
    <Route
      {...{
        render: (matchProps) => (
          <Layout>
            <Component {...matchProps} />
          </Layout>
        ),
        ...rest,
      }}
    />
  );
};

export default RouteWithLayout;
